import { GameVars } from "../GameVars";
import { GameConstants } from "../GameConstants";
import { AudioManager } from "../AudioManager";

    export class FieldBoundaries extends Phaser.Group {

        public static LEFT_POST_PX: number = 218;
        public static DELTA_X_POST: number = 332;

        constructor(game: Phaser.Game) {

            super(game, null, "field boundaries", false);

            let upperWall_py: number;

            let post_py: number;
            
            if (GameVars.penalties) {
                upperWall_py = -340;
                post_py = 780 / (GameVars.scaleY * GameVars.fieldCorrectionScaleY);
            } else {
                upperWall_py = -495;
                post_py = 980;
            }

            let upperAndSideWalls = new Phaser.Sprite(this.game, GameConstants.GAME_WIDTH / 2, upperWall_py );
            this.add(upperAndSideWalls);
            this.game.physics.p2.enable( upperAndSideWalls, GameConstants.SHOW_PHYSICS_BODIES );
            upperAndSideWalls.body.setRectangle(768, 1000);

            // izquierda
            upperAndSideWalls.body.addRectangle( 305, 1200, -534, 1000);
            // derecha
            upperAndSideWalls.body.addRectangle( 305, 1200, 534, 1000);
            upperAndSideWalls.body.mass = 50;
            upperAndSideWalls.body.setMaterial(GameVars.getInstance().materials.shockAbsorberMaterial);
            upperAndSideWalls.body.static = true;

            const posts = new Phaser.Sprite(this.game, FieldBoundaries.LEFT_POST_PX , post_py);
            this.add(posts);

            this.game.physics.p2.enable( posts, GameConstants.SHOW_PHYSICS_BODIES);
            posts.body.setCircle(18);
            posts.body.addCircle(18, FieldBoundaries.DELTA_X_POST , 0);
            posts.body.setMaterial(GameVars.getInstance().materials.postMaterial);
            posts.body.static = true;
            posts.body.onBeginContact.add(this.ballHitPosts, this);
        }

        private ballHitPosts (body: any, shapeA: any, shapeB: any, equation: any): void {

            AudioManager.getInstance().playEffect("madera_solida_1");
        }
    }
